/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable max-len */
// @flow
/* eslint-disable react/no-danger */
import * as React from 'react';
import { Col, Row } from 'antd';
import cn from 'classnames';
import { connect } from 'react-redux';
import type { Store } from 'client/reducers';
// import _ from 'lodash';

import { dataLayerEvents } from 'common/utils';
import * as css from './Intro.scss';

type Props = {|
	className?: string,
|};

class Intro extends React.PureComponent<Props> {
	static defaultProps = {
		className: '',
	};

	componentDidMount() {
		const script = document.createElement('script');
		script.src = 'https://ynet-bagrut-2023.firebaseapp.com/assets/embed.js';
		// script.src = 'http://localhost:8000/assets/embed.js';
		script.async = true;
		script.onload = () => window.embedWidget('bagrut-top', 'top?shrink=1');

		const script2 = document.createElement('script');
		script2.src = 'https://ynet-bagrut-2023.firebaseapp.com/assets/embed.js';
		// script2.src = 'http://localhost:8000/assets/embed.js';
		script2.onload = () => window.embedWidget('bagrut-comparison', 'comparison?shrink=1');
		script2.async = true;
		const { body } = document;
		if (body) {
			body.append(script, script2);
		}
	}

	componentDidUpdate(prevProps: Props) {}

	onLinkBlockClick = (e: SyntheticEvent<HTMLAnchorElement>) => {
		dataLayerEvents.articleLinkClick(e.currentTarget.href);
	};

	render() {
		const { className } = this.props;
		return (
			<div className={cn(css.intro, className)}>
				<div className={css.iframe__block}>
					<Row justify="center" type="flex" gutter={24}>
						<Col span={24} order={4} sm={{ span: 10, order: 3 }}>
							<div className={css.iframe__wrapper}>
								<div id="bagrut-top"></div>
							</div>
						</Col>
						<Col span={24} sm={{ span: 10, order: 4 }} xs={{ order: 1 }}>
							<div className={css.iframe__wrapper}>
								<div id="bagrut-comparison"></div>
							</div>
						</Col>
					</Row>
				</div>
			</div>
		);
	}
}

const mapState = (store: Store): Props => ({});

const mapDispatch = {};

export default connect(mapState, mapDispatch)(Intro);
